import { handleActions } from 'redux-actions';
import { defaultAuthorizedAppsWidgetState } from './defaults';
import { initSecurityPage } from '../../actions';
import { AuthorizedAppsWidgetData } from './types';
import {
  removeAuthorizedAppWidgetAuthorizedApp,
  removeAuthorizedAppWidgetAuthorizedAppFailure,
  removeAuthorizedAppWidgetAuthorizedAppSuccess,
} from './actions';
import { NetworkRequestState } from '../baseTypes';

export default handleActions<AuthorizedAppsWidgetData, any>(
  {
    [initSecurityPage.toString()]: (
      state,
      action: ReturnType<typeof initSecurityPage>
    ) => {
      const data: AuthorizedAppsWidgetData = {
        authorizedApps: action.payload.data.apps,
        request: {
          status: NetworkRequestState.IDLE,
          errors: {},
        },
      };
      return data;
    },
    [removeAuthorizedAppWidgetAuthorizedApp.toString()]: (
      state,
      action: ReturnType<typeof removeAuthorizedAppWidgetAuthorizedApp>
    ) => ({
      ...state,
      request: {
        status: NetworkRequestState.SENT_AND_WAITING_FOR_RESPONSE,
        errors: {},
      },
    }),
    [removeAuthorizedAppWidgetAuthorizedAppSuccess.toString()]: (
      state,
      action: ReturnType<typeof removeAuthorizedAppWidgetAuthorizedAppSuccess>
    ) => ({
      ...state,
      authorizedApps: state.authorizedApps.filter(
        app => app.deviationId !== action.payload.deviationId
      ),
      request: {
        status: NetworkRequestState.IDLE,
        errors: {},
      },
    }),
    [removeAuthorizedAppWidgetAuthorizedAppFailure.toString()]: (
      state,
      action: ReturnType<typeof removeAuthorizedAppWidgetAuthorizedAppFailure>
    ) => ({
      ...state,
      request: {
        status: NetworkRequestState.FAILURE,
        errorMessage: action.payload.errorMessage,
        // TODO: parse errors for authorized apps
        errors: {},
      },
    }),
  },
  defaultAuthorizedAppsWidgetState
);
